<template>
  <input type="text" class="form-control" :value="value" :placeholder="placeholder">
</template>

<script>
export default {
  props: [ 'format', 'value', 'placeholder' ],
  mounted () {
    this.$emit('update-date', this.value)

    var self = this
    $(this.$el).datetimepicker({
      format: this.format
    })
      .on('dp.change', function (e) {
        self.$emit('update-date', e.date.format(self.format))
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DateTimePicker.vue